/**
 * Feature Tooltips Component
 *
 * This component renders tooltips for the amenities
 */

// deps

// internals
const { Fragment} = React;

import iconData from './data/amenityIconInformation';

const features = () => {

  const iconKeys = Object.keys(iconData);

  return (
    <Fragment>
      {
        iconKeys.map(key => {

          const {
            className = '',
            popover = '',
            featureName = '',
            description = '',
            learnMore = '',
          } = iconData[key];

          return (
            <div key={ key } id={ popover } className="popover-content-wrap pr">
              <div className="close-tooltip">
                <i className="icon-close" />
              </div>
              <div className="popover-section-icon hidden-large-down">
                <span className={`${ className }`}>
                  <span className="sr-only">{ featureName }</span>
                </span>
              </div>
              <div className="popover-section-content">
                <h2 className="opensans-regular">{featureName}</h2>
                <p>{description}</p>
                {
                  learnMore &&
                  <p>
                    <a className="link-more" href={learnMore}>
                      Learn More
                    </a>
                  </p>
                }
              </div>
            </div>
          );
        })
      }
    </Fragment>
  );
};

export default features;
